import { TransfersScreen } from './screens/transfers-screen.jsx';
import { SchedulesScreen } from './screens/schedules-screen.jsx';
import { CurrenciesScreen } from './screens/currencies-screen.jsx';
import { MultiCurrencyScreen } from './screens/multi-currency-screen.jsx';
import { ReportsScreen } from './screens/reports-screen.jsx';
import { TagsScreen } from './screens/tags-screen.jsx';
import { ImportScreen } from './screens/import-screen.jsx';
import { MobileScreen } from './screens/mobile-screen.jsx';
import { ApiScreen } from './screens/api-screen.jsx';
import { VisualiseScreen } from './screens/visualise-screen.jsx';
import { LanguageScreen } from './screens/language-screen.jsx';

/**
 * @typedef {Object} UseCase
 * @property {string} slug — used for the route (`/use-cases/:slug`) and for
 *   locale keys (`usecase.<slug>.title`, `.lede`, `.body`).
 * @property {string} icon — the line-icon kind rendered on the use-case cards.
 * @property {boolean} [featured] — shown on the home page grid.
 * @property {() => import('react').ReactElement} Screen — renders the mockup.
 */

/**
 * Use-case registry. The home grid, the `/use-cases/:slug` route, and the
 * "other use cases" nav all render from this list, so adding a use case is
 * one registry entry + one screen component + its locale keys.
 * @type {Array<UseCase>}
 */
export const USE_CASES = [
	{ slug: 'transfers', icon: 'swap', Screen: TransfersScreen, featured: true },
	{ slug: 'schedules', icon: 'clock', Screen: SchedulesScreen, featured: true },
	{ slug: 'currencies', icon: 'coin', Screen: CurrenciesScreen },
	{ slug: 'multi-currency', icon: 'globe', Screen: MultiCurrencyScreen },
	{ slug: 'reports', icon: 'sprout', Screen: ReportsScreen, featured: true },
	{ slug: 'visualise', icon: 'bar-chart', Screen: VisualiseScreen, featured: true },
	{ slug: 'tags', icon: 'tag', Screen: TagsScreen },
	{ slug: 'import', icon: 'inbox', Screen: ImportScreen },
	{ slug: 'mobile', icon: 'phone', Screen: MobileScreen },
	{ slug: 'api', icon: 'code', Screen: ApiScreen },
	{ slug: 'language', icon: 'map', Screen: LanguageScreen },
];

/**
 * @param {string} slug
 * @returns {UseCase | undefined}
 */
export function getUseCase(slug) {
	return USE_CASES.find((u) => u.slug === slug);
}
